import { useChangeSearch, useSearch } from '@btime/react-contexts'
import React from 'react'

import SearchInput from '../../../components/form/SearchInput'

const ControlBar = ({ selectedScreen, children }) => {
  const changeSearch = useChangeSearch()
  const search = useSearch()

  return <SearchInput value={search} onStopTyping={changeSearch} />
}

export default ControlBar
